import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import { useAuth } from '../contexts/AuthContext';
import styled from 'styled-components';

const LoadingContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #00d4aa 0%, #00b894 100%);
`;

const LoadingCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
`;

const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #00d4aa;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

export const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated: isAdminAuthenticated, isLoading: isAdminLoading } = useAdminAuth();
  const { isAdmin, isSuperAdmin, isLoading: isAuthLoading } = useAuth();
  const location = useLocation();

  const isLoading = isAdminLoading || isAuthLoading;
  const isAuthenticated = isAdminAuthenticated || isAdmin || isSuperAdmin;

  if (isLoading) {
    return (
      <LoadingContainer>
        <LoadingCard>
          <LoadingSpinner />
          <div>Verificando permissões de administrador...</div>
        </LoadingCard>
      </LoadingContainer>
    );
  }

  if (!isAuthenticated) {
    // Redirecionar para login de admin, salvando a localização atual
    return <Navigate to="/app/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};